import { Control, Controller } from "react-hook-form";

import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import type { SxProps } from "@mui/material/styles";

import InputFormField from "components/input-form-field";

import { InventoryProductSpecificationValues } from "../inventory-product-specification-form.component";

export type HearingAidSpecificationValues = {
  battery: string;
  color: string;
  manufacturer_instruction: string;
  additional_notes: string;
};
export const EMPTY_HEARING_AID_SPECIFICATION: HearingAidSpecificationValues = {
  battery: "",
  color: "",
  manufacturer_instruction: "",
  additional_notes: ""
};

type HearingAidSpecificationFormProps = {
  control: Control<InventoryProductSpecificationValues, object>;
  sx?: SxProps;
};

export default function HearingAidSpecificationForm({
  control,
  sx
}: HearingAidSpecificationFormProps) {
  return (
    <>
      <Stack direction="row" sx={{ width: "100%", ...sx }} spacing={2}>
        <InputFormField
          name="hearing_aid.color"
          label="Color"
          placeholder="Color"
          control={control}
          sx={{ ml: 0 }}
        />
        <InputFormField
          name="hearing_aid.battery"
          label="Battery"
          placeholder="Battery"
          control={control}
          sx={{ ml: 0 }}
        />
        <Controller
          name="hearing_aid.manufacturer_instruction"
          control={control}
          render={({ field }) => (
            <TextField
              label="Manufacturer Instructions"
              placeholder="Enter Manufacturer Instructions"
              variant="outlined"
              multiline
              fullWidth
              minRows={2}
              maxRows={20}
              {...field}
            />
          )}
        />
      </Stack>
      <InputFormField
        name="hearing_aid.additional_notes"
        label="Additional notes"
        control={control}
        sx={{ ml: 0, mt: 4 }}
        multiline
      />
    </>
  );
}
